import React from "react";

import { useTranslation } from "react-i18next";
import { useAuthentication } from "@planzone/view-models";
import { ProfilePicture } from "./profilePicture";
import { Props } from "./types";
import styles from "./styles.scss";

function Profile(props: Props) {
  const { t } = useTranslation();
  const { account } = useAuthentication();

  return (
    <div className={styles.profile}>
      <div className={styles.row}>
        <ProfilePicture className={styles.profilePicture} />
        <h3 className={styles.name}>{account.resource.name}</h3>
      </div>
      <div className={styles.group}>
        <h4 className={styles.subTitle}>{t("preferences.profile.name")}</h4>
        <p className={styles.text}>
          {account.firstName} {account.lastName}
        </p>
      </div>
      <div className={styles.group}>
        <h4 className={styles.subTitle}>{t("preferences.profile.email")}</h4>
        <p className={styles.text}>{account.email}</p>
      </div>
      {account.resource.tags.length > 0 && (
        <div className={styles.group}>
          <h4 className={styles.subTitle}>{t("preferences.profile.tags")}</h4>
          <div className={styles.tags}>
            {account.resource.tags.map((tag) => (
              <div key={tag.name} className={styles.tag}>
                <p>{tag.name}</p>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export { Profile };
